import axios from 'axios'
import * as Types from '../types'

export default
{
	state:
	{
		details:      null,
		contactTypes: null,

		contactMethodTypes: null,
	},

	getters:
	{
		isOrderContact:  (state, getters) => state && state.details && state.details.order_id && state.details.contact && !!state.details.contact.id,
		contact:         (state, getters) => state && state.details && getters && ( getters.isOrderContact ? state.details.contact : state.details ),
		hasContact:      (state, getters) => getters && getters.contact && !!getters.contact.id,
		contactFullName: (state, getters) => getters && getters.contact && [ getters.contact.first_name, getters.contact.last_name ].join(' '),
		contactMethods:  (state, getters) => getters && getters.contact && getters.contact.contact_methods,
		contactType:     (state, getters) => getters && getters.isOrderContact && state && state.details && state.details.contact_type,
		detailsId:       (state, getters) => getters && state && state.details && state.details.id,
		contactOrderId:  (state, getters) => getters && state && state.details && state.details.order_id,

		hasContactTypes:       state => state && state.contactTypes && state.contactTypes.length > 0,
		hasContactMethodTypes: state => state && state.contactMethodTypes && state.contactMethodTypes.length > 0,
	},

	mutations:
	{
		[Types.CCDB_CLEAR](state)
		{
			state.details = null
		},

        [Types.CCDB_DETAILS](state, details)
		{
            state.details = details
        },

        [Types.CCDB_ORDER_CONTACT_TYPES](state, contactTypes)
		{
            state.contactTypes = contactTypes
        },

        [Types.CCDB_CONTACT_METHOD_TYPES](state, contactMethodTypes)
		{
            state.contactMethodTypes = contactMethodTypes
        },
	},

	actions:
	{
		[Types.CCDB_CONTACT_METHOD_TYPES]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/lookup/notification-types')
						.then
						(
							response =>
							{
								commit(Types.CCDB_CONTACT_METHOD_TYPES, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_CLEAR]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					commit(Types.CCDB_CLEAR)
					resolve()
				}
			)
		},

		[Types.CCDB_DETAILS]({ commit }, {ccdbId})
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/ccdb/' + ccdbId)
						.then
						(
							response =>
							{
								commit(Types.CCDB_DETAILS, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_ORDER_CONTACT_TYPES]({ commit }, { orderId, ccdbToOrderId })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/orders/' + orderId + '/contacts/contact-types' + ( ccdbToOrderId ? '/' + ccdbToOrderId : '' ))
						.then
						(
							response =>
							{
								commit(Types.CCDB_ORDER_CONTACT_TYPES, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_ORDER_CREATE]({ dispatch }, { orderId, ccdbToOrderId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/orders/' + orderId + '/contacts/create', data)
						.then
						(
							async response =>
							{
								await dispatch(Types.ORDER_DETAILS, { orderId })

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_ORDER_DETAILS]({ commit }, { orderId, ccdbToOrderId })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/orders/' + orderId + '/contacts/' + ccdbToOrderId)
						.then
						(
							response =>
							{
								commit(Types.CCDB_DETAILS, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_ORDER_UPDATE]({ dispatch }, { orderId, ccdbToOrderId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/orders/' + orderId + '/contacts/' + ccdbToOrderId + '/update', data)
						.then
						(
							async response =>
							{
								await dispatch(Types.ORDER_DETAILS, { orderId })

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_ORDER_DELETE]({ dispatch }, { orderId, ccdbToOrderId })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.delete('/api/orders/' + orderId + '/contacts/' + ccdbToOrderId + '/delete')
						.then
						(
							async response =>
							{
								await dispatch(Types.ORDER_DETAILS, { orderId })

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_CONTACT_METHOD_CREATE]({ dispatch }, { ccdbId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/ccdb/' + ccdbId + '/contact-methods', data)
						.then
						(
							async response =>
							{
								await dispatch(Types.CCDB_DETAILS, { ccdbId })

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_CONTACT_METHOD_UPDATE]({ dispatch }, { ccdbId, contactMethodId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/ccdb/' + ccdbId + '/contact-methods/' + contactMethodId, data)
						.then
						(
							async response =>
							{
								await dispatch(Types.CCDB_DETAILS, { ccdbId })

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_CONTACT_METHOD_DELETE]({ dispatch }, { ccdbId, contactMethodId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.delete('/api/ccdb/' + ccdbId + '/contact-methods/' + contactMethodId, data)
						.then
						(
							async response =>
							{
								await dispatch(Types.CCDB_DETAILS, { ccdbId })

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_ORDER_CONTACT_METHOD_CREATE]({ dispatch }, { orderId, ccdbToOrderId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/orders/' + orderId + '/contacts/' + ccdbToOrderId + '/contact-methods', data)
						.then
						(
							async response =>
							{
								await dispatch(Types.CCDB_ORDER_DETAILS, { orderId, ccdbToOrderId })

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_ORDER_CONTACT_METHOD_UPDATE]({ dispatch }, { orderId, ccdbToOrderId, contactMethodId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/orders/' + orderId + '/contacts/' + ccdbToOrderId + '/contact-methods/' + contactMethodId, data)
						.then
						(
							async response =>
							{
								await dispatch(Types.CCDB_ORDER_DETAILS, { orderId, ccdbToOrderId })

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.CCDB_ORDER_CONTACT_METHOD_DELETE]({ dispatch }, { orderId, ccdbToOrderId, contactMethodId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.delete('/api/orders/' + orderId + '/contacts/' + ccdbToOrderId + '/contact-methods/' + contactMethodId, data)
						.then
						(
							async response =>
							{
								await dispatch(Types.CCDB_ORDER_DETAILS, { orderId, ccdbToOrderId })

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},
	},
}